import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareAuthCheckData, ShareOwnerData } from '../../types';
import type { ShareOwnerInfoApi } from '../share-owner-info-api';

@injectable()
export class ShareOwnerInfoApiImpl extends PsHttpService implements ShareOwnerInfoApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getShareOwnerInfo(inputData: ShareAuthCheckData) {
        return this.get<PatSnapCommonResponseData<ShareOwnerData>>({
            url: '/share/owner',
            params: inputData,
        }).then((res) => {
            return res.data as ShareOwnerData;
        });
    }
}
